// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VueRouter from 'vue-router'
import ElementUI from 'element-ui'
import App from './App'
import OssUpload from './components/OssUpload.vue'
import UploadButton from './components/UploadButton.vue'
import UploadPicture from './components/UploadPicture.vue'
import UploadVideo from './components/UploadVideo.vue'

import router from './router'

import 'element-ui/lib/theme-chalk/index.css';
import '../static/css/global.css' /*引入公共样式*/
import '../static/css/global_all.css' /*引入公共样式*/
import 'element-ui/lib/theme-chalk/display.css';

import adminApi from './util/common.js';
import { installApiClient } from './util/api';
import { getToken, migrateLegacySessionToken, setToken } from './util/auth';
import VueResource from 'vue-resource';

// Legacy UEditor assets are intentionally not loaded by default.
// The active admin editing experience uses Quill-based components instead.

// 富文本样式
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'


Vue.use(VueRouter)
Vue.use(ElementUI)
Vue.use(VueResource)
installApiClient(Vue)
Vue.component('OssUpload', OssUpload)
Vue.component('UploadButton', UploadButton)
Vue.component('UploadPicture', UploadPicture)
Vue.component('UploadVideo', UploadVideo)

// 路由守卫
router.beforeEach((to, from, next) => {
  // 分销及推三页面永久关闭；提现使用独立余额管理路由。
  if (to.path.indexOf('/distribution/') === 0 || to.path === '/nav2/invitation_set') {
    ElementUI.Message.warning('功能已停用');
    return next('/banner/swiper');
  }
  // 开发环境便捷登录：支持在 URL 上带 token 自动写入 localStorage
  // 例：http://127.0.0.1:8080/#/nav1/shop_list?token=xxx
  if (process.env.NODE_ENV !== 'production' && to.query && to.query.token) {
    setToken(String(to.query.token));
  }
  if (to.path === '/Login') return next()
  migrateLegacySessionToken()
  const token = getToken()
  // 判断token的状态,取反则没有token，让用户去登录
  if (!token) return next('/Login')
  next()
})

//定义全局变量
Vue.prototype.adminApi = adminApi;

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js